import serverModeService from './serverModeService';

const EVENT = 'coldstorage:local-auth-changed';

const asLocalUser = (session) => {
  if (!session?.user) return null;
  const raw = session.user || {};
  const uid = String(raw.uid || raw.id || raw.authUid || '').trim();
  if (!uid) return null;
  return {
    ...raw,
    uid,
    id: raw.id || uid,
    email: String(raw.email || '').trim().toLowerCase(),
    displayName: raw.displayName || raw.name || raw.fullName || '',
    emailVerified: true,
    isAnonymous: false,
    providerId: 'frostflow-local',
    isLocalOffline: true,
    getIdToken: async () => String(serverModeService.getLocalAuthSession()?.sessionToken || ''),
    getIdTokenResult: async () => ({ token: String(serverModeService.getLocalAuthSession()?.sessionToken || ''), claims: { localOffline: true } }),
    reload: async () => {},
  };
};

const service = {
  EVENT,

  async bootstrap() {
    await serverModeService.bootstrapSameOrigin({ silent: true });
    return this.getSession();
  },

  getSession() {
    return serverModeService.getLocalAuthSession();
  },

  getUser() {
    return asLocalUser(this.getSession());
  },

  async login(email, password, options = {}) {
    const session = await serverModeService.localAuthLogin(email, password, options);
    return { ...session, user: asLocalUser(session) };
  },

  async logout() {
    await serverModeService.localAuthLogout();
  },

  subscribe(listener) {
    if (typeof window === 'undefined') return () => {};
    const handler = () => listener?.(this.getUser(), this.getSession());
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  },
};

export default service;
